module.exports = __webpack_public_path__ + "static/media/dtj-mockup-5.54def70f.jpg";